class EventsBlock extends HTMLElement {
  constructor() {
    super()
    this.buttons = this.querySelectorAll('[data-tag-selector]')
    this.items = this.querySelectorAll('[data-event-line]')
    this.filter_events_1 = this.querySelectorAll('.page-events__filter-select__events_1__button')
    this.filter_events_2 = this.querySelectorAll('.page-events__filter-select__events_2__button')
    this.filter_events_3 = this.querySelectorAll('.page-events__filter-select__events_3__button')
    this.close_filter = this.querySelectorAll('.page-events__filter--close__button')
    this.event_header = this.querySelectorAll('.page-events__header')
    this.initEvents()
  }

  initEvents() {
    this.buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.target.classList.toggle('event-tag--active')
        this.updateEvents()

        var handlized_tag = e.target.attributes['data-tag-handle'].value
        var filters = ''

        $('.page-events__checkbox-wrapper').each(function() {
          if ($(this).hasClass('event-tag--active')) {
            if (filters.length < 1) {
              filters = '#' + $(this).attr('data-tag-handle')
            } else {
              filters = filters + '&' + $(this).attr('data-tag-handle');
            }            
          }
        })

        window.history.pushState({ path: window.location.href }, '#', filters);
        
      })
    })

    this.close_filter.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.target.closest('.page-events__filter-select__events').classList.toggle('active')
      })
    })
    
    this.filter_events_1.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.target.closest('.page-events__filter-select__events_1').classList.toggle('active')
      })
    })

    this.filter_events_2.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.target.closest('.page-events__filter-select__events_2').classList.toggle('active')
      })
    })

    this.filter_events_3.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.target.closest('.page-events__filter-select__events_3').classList.toggle('active')
      })
    })

    this.event_header.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (e.target.closest('.page-events__block').classList.contains('always__closed')) {} 
        else { e.target.closest('.page-events__block').classList.toggle('active'); }
      })
    })
  }

  updateEvents() {
    const activeButtons = this.querySelectorAll('.event-tag--active')
    if (activeButtons.length > 0) {
      const activeTags = []
      activeButtons.forEach((btn) => {
        activeTags.push(btn.dataset.tagSelector)
      })
      this.items.forEach((item) => {
    
        let includeTag = false
        activeTags.forEach((tag) => {
          if (item.dataset.tags && item.dataset.tags.includes(tag)) includeTag = true
        })
        if (includeTag) item.classList.remove('hidden')
        else item.classList.add('hidden')
      })
    } else {
      this.items.forEach((item) => item.classList.remove('hidden'))
    }
  }
}

customElements.define('events-block', EventsBlock);
